import { render } from "./StatsByProduct.vue?vue&type=template&id=34af5d63"
import script from "./StatsByProduct.vue?vue&type=script&lang=js"
export * from "./StatsByProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__